import React, { ReactNode } from 'react';
import * as BuilderInfoUI from '../BuilderInfoUI';
import { IndexedIcon } from '../../Icon';

interface IProps {
  iconName: 'expand-event-active' | 'fold-event-active' | 'merge-event-active';
  iconPositiveIndex: number;
  children: ReactNode;
}

export default ({ iconName, iconPositiveIndex, children }: IProps) => (
  <BuilderInfoUI.HorizontalRow>
    <IndexedIcon
      name={iconName}
      positiveIndex={iconPositiveIndex}
      isActive={true}
    />
    <BuilderInfoUI.VerticalSeparator />
    {children}
  </BuilderInfoUI.HorizontalRow>
);
